module.exports = __webpack_public_path__ + "img/Skilled Communicator.85d74d5f.svg";